import client from '../client'

export const getDecodeShortTrimsKey = `${process.env.NEXT_PUBLIC_INTEGRATION_DATAKIOSK_ENDPOINT}/GetDecodeShortTrims`

export async function getDecodeShortTrims({ modelId }) {
  const params = new URLSearchParams({ modelId: modelId.toString() })

  return client(`${getDecodeShortTrimsKey}?${params.toString()}`)
}
